export const traitLabels = {
  PRODUCT_TYPE_MAKEUP: 'Maquiagem',
  PRODUCT_TYPE_SKIN: 'Pele e corpo',
  PRODUCT_TYPE_HAIR: 'Cabelo',

  MAKEUP_PRODUCT_TYPE_REGULAR_LIPSTICK: 'Batom',
  MAKEUP_PRODUCT_TYPE_LIQUID_LIPSTICK: 'Batom líquido',
  MAKEUP_PRODUCT_TYPE_LIP_TINT: 'Lip tint',
  MAKEUP_PRODUCT_TYPE_GLOSS: 'Gloss',
  MAKEUP_PRODUCT_TYPE_LIP_LINER: 'Lápis de boca',
  MAKEUP_PRODUCT_TYPE_FOUNDATION: 'Base',
  MAKEUP_PRODUCT_TYPE_CONCEALER: 'Corretivo',
  MAKEUP_PRODUCT_TYPE_PRIMER: 'Primer',
  MAKEUP_PRODUCT_TYPE_MAKEUP_FIXER: 'Fixador de maquiagem',
  MAKEUP_PRODUCT_TYPE_BLUSH: 'Blush',
  MAKEUP_PRODUCT_TYPE_FACE_POWDER: 'Pó facial',
  MAKEUP_PRODUCT_TYPE_BRUSH: 'Pincel',
  MAKEUP_PRODUCT_TYPE_MAKEUP_SPONGE: 'Esponja de maquiagem',
  MAKEUP_PRODUCT_TYPE_ILLUMINATOR: 'Iluminador',
  MAKEUP_PRODUCT_TYPE_BRONZER: 'Bronzer',
  MAKEUP_PRODUCT_TYPE_PENCIL_EYELINER: 'Lápis de olho',
  MAKEUP_PRODUCT_TYPE_EYE_PIGMENT: 'Pigmento para olhos',
  MAKEUP_PRODUCT_TYPE_EYELINER: 'Delineador',
  MAKEUP_PRODUCT_TYPE_EYESHADOW: 'Sombra',
  MAKEUP_PRODUCT_TYPE_MASCARA: 'Máscara de cílios',
  MAKEUP_PRODUCT_TYPE_EYEBROW_PRODUCTS: 'Sobrancelha',
  MAKEUP_PRODUCT_TYPE_NAIL_POLISH: 'Esmalte',

  HAIR_PRODUCT_TYPE_SHAMPOO: 'Shampoo',
  HAIR_PRODUCT_TYPE_CONDITIONER: 'Condicionador',
  HAIR_PRODUCT_TYPE_DRY_SHAMPOO: 'Shampoo a seco',
  HAIR_PRODUCT_TYPE_CAPILLARY_MASK: 'Máscara capilar',
  HAIR_PRODUCT_TYPE_REPAIRING_OIL: 'Óleo reparador',
  HAIR_PRODUCT_TYPE_LEAVE_IN: 'Leave-in',
  HAIR_PRODUCT_TYPE_HAIR_FIXER: 'Fixador de cabelo',

  SKIN_PRODUCT_TYPE_FACIAL_SOAP: 'Sabonete facial',
  SKIN_PRODUCT_TYPE_LIQUID_BODY_SOAP: 'Sabonete líquido corporal',
  SKIN_PRODUCT_TYPE_SOLID_BODY_SOAP: 'Sabonete em barra corporal',
  SKIN_PRODUCT_TYPE_HAND_LOTION: 'Creme para as mãos',
  SKIN_PRODUCT_TYPE_BODY_OIL: 'Óleo corporal',
  SKIN_PRODUCT_TYPE_BODY_LOTION: 'Hidratante corporal',
  SKIN_PRODUCT_TYPE_FACE_MOISTURIZER: 'Hidratante facial',
  SKIN_PRODUCT_TYPE_BODY_EXFOLIATOR: 'Esfoliante corporal',
  SKIN_PRODUCT_TYPE_FACIAL_EXFOLIATOR: 'Esfoliante facial',
  SKIN_PRODUCT_TYPE_LIP_EXFOLIATOR: 'Esfoliante labial',
  SKIN_PRODUCT_TYPE_FACIAL_CLEANSING: 'Limpeza facial',
  SKIN_PRODUCT_TYPE_LIP_MOISTURIZER: 'Hidratante labial',
  SKIN_PRODUCT_TYPE_SUNSCREEN: 'Protetor solar',
  SKIN_PRODUCT_TYPE_FACIAL_TONER: 'Tônico facial',
  SKIN_PRODUCT_TYPE_FACIAL_MASK: 'Máscara facial',
  SKIN_PRODUCT_TYPE_EYE_MASK: 'Máscara para os olhos',
  SKIN_PRODUCT_TYPE_EYE_AREA_TREATMENT: 'Tratamento para a área dos olhos',
  SKIN_PRODUCT_TYPE_FACIAL_SERUM: 'Sérum facial',
  SKIN_PRODUCT_TYPE_MAKEUP_REMOVER: 'Demaquilante',
  SKIN_PRODUCT_TYPE_FRAGRANCE: 'Perfume',
  SKIN_PRODUCT_TYPE_DEODORANT: 'Desodorante',
  SKIN_PRODUCT_TYPE_FEET_CARE: 'Cuidado com os pés',

  SKIN_COLOR_TYPE_1: 'Muito clara',
  SKIN_COLOR_TYPE_2: 'Clara',
  SKIN_COLOR_TYPE_3: 'Média clara',
  SKIN_COLOR_TYPE_4: 'Média',
  SKIN_COLOR_TYPE_5: 'Média escura',
  SKIN_COLOR_TYPE_6: 'Escura',

  SKIN_OILNESS_DRY: 'Oleosidade antiga: seca',
  SKIN_OILNESS_NORMAL: 'Oleosidade antiga: normal',
  SKIN_OILNESS_MIXED: 'Oleosidade antiga: mista',
  SKIN_OILNESS_OILY: 'Oleosidade antiga: oleosa',

  FACIAL_SKIN_OILNESS_DRY: 'Seca',
  FACIAL_SKIN_OILNESS_NORMAL: 'Normal',
  FACIAL_SKIN_OILNESS_MIXED: 'Mista',
  FACIAL_SKIN_OILNESS_OILY: 'Oleosa',

  BODY_SKIN_OILNESS_DRY: 'Seca',
  BODY_SKIN_OILNESS_NORMAL: 'Normal',
  BODY_SKIN_OILNESS_OILY: 'Oleosa',

  SKIN_ISSUE_DRYNESS: 'Ressecamento',
  SKIN_ISSUE_EXCESSIVE_OILNESS: 'Oleosidade excessiva',
  SKIN_ISSUE_ACNE: 'Acne',
  SKIN_ISSUE_SENSITIVITY: 'Sensibilidade',
  SKIN_ISSUE_WRINKLES: 'Rugas',
  SKIN_ISSUE_SKIN_STAINS: 'Manchas',
  SKIN_ISSUE_DARK_CIRCLES_AROUND_EYES: 'Olheiras',

  SKIN_PREFERRED_SCENT_FRESH: 'Fresco',
  SKIN_PREFERRED_SCENT_WOODY: 'Amadeirado',
  SKIN_PREFERRED_SCENT_CITRUS: 'Cítrico',
  SKIN_PREFERRED_SCENT_SWEET: 'Doce',
  SKIN_PREFERRED_SCENT_FRUITY: 'Frutado',
  SKIN_PREFERRED_SCENT_FLORAL: 'Floral',

  HAIR_COLOR_BLOND: 'Loiro',
  HAIR_COLOR_ASHEN: 'Grisalho',
  HAIR_COLOR_BROWN: 'Castanho',
  HAIR_COLOR_BLACK: 'Preto',
  HAIR_COLOR_RED: 'Ruivo',
  HAIR_COLOR_COLORED: 'Colorido',

  HAIR_TYPE_STRAIGHT: 'Liso',
  HAIR_TYPE_WAVY: 'Ondulado',
  HAIR_TYPE_CURLY: 'Cacheado',
  HAIR_TYPE_COILY: 'Crespo',

  HAIR_OILNESS_DRY: 'Seco',
  HAIR_OILNESS_NORMAL: 'Normal',
  HAIR_OILNESS_OILY: 'Oleoso',

  HAIR_CHEMICAL_NATURAL: 'Natural',
  HAIR_CHEMICAL_CHEMICALLY_TREATED: 'Com química',

  HAIR_ISSUE_FRIZZ: 'Frizz',
  HAIR_ISSUE_SPLIT_ENDS: 'Pontas duplas',
  HAIR_ISSUE_DRYNESS: 'Ressecamento',
  HAIR_ISSUE_EXCESSIVE_OILNESS: 'Oleosidade excessiva',
  HAIR_ISSUE_TOO_LITTLE_VOLUME: 'Pouco volume',
  HAIR_ISSUE_TOO_MUCH_VOLUME: 'Muito volume',

  LIPSTICK_COLOR_NUDE: 'Nude',
  LIPSTICK_COLOR_PINK: 'Rosa',
  LIPSTICK_COLOR_RED: 'Vermelho',
  LIPSTICK_COLOR_PURPLE: 'Roxo',
  LIPSTICK_COLOR_EXOTIC_COLORS: 'Cores exóticas',

  SHADOW_COLOR_NEUTRAL: 'Neutra',
  SHADOW_COLOR_COLORFUL: 'Colorida',

  EYELIINER_COLOR_BEIGE: 'Bege',
  EYELIINER_COLOR_BROWN: 'Marrom',
  EYELIINER_COLOR_BLACK: 'Preto',
  EYELIINER_COLOR_COLORFUL: 'Colorido',

  // The exclusion families go by main function, which the EXCLUSION_FAMILY hint explains
  MUTUAL_EXCLUSION_MAKEUP_APPLICATION_TOOL: 'Aplicador de maquiagem',
  MUTUAL_EXCLUSION_LIPSTICK: 'Produto para lábios',
  MUTUAL_EXCLUSION_PENCIL: 'Lápis',
  MUTUAL_EXCLUSION_LIQUID_LIP_PRODUCT: 'Produto líquido para lábios',
  MUTUAL_EXCLUSION_EYE_LINING_PRODUCT: 'Traço para olhos',
  MUTUAL_EXCLUSION_LOTION: 'Hidratante, loção ou creme',
  MUTUAL_EXCLUSION_BODY_SOAP: 'Sabonete corporal',
  MUTUAL_EXCLUSION_SOLID_SOAP: 'Sabonete em barra',
  MUTUAL_EXCLUSION_EXFOLIATOR: 'Esfoliante',

  EXCLUSIVE_SKIN_ISSUE_ACNE: 'Só para quem tem acne',
  EXCLUSION_SKIN_ISSUE_SENSITIVITY: 'Não enviar para pele sensível',
  EXCLUSIVE_HAIR_ISSUE_TOO_LITTLE_VOLUME: 'Só para quem tem pouco volume',
};

export const groupLabels = {
  SKIN_COLOR: 'Tom de pele',
  FACIAL_SKIN_OILNESS: 'Oleosidade da pele do rosto',
  BODY_SKIN_OILNESS: 'Oleosidade da pele do corpo',
  HAIR_COLOR: 'Cor do cabelo',
  HAIR_TYPE: 'Tipo de cabelo',
  HAIR_OILNESS: 'Oleosidade do cabelo',
  HAIR_CHEMICAL: 'Química no cabelo',
  LIPSTICK_COLOR: 'Cor de batom',
  SHADOW_COLOR: 'Cor de sombra',
  EYELINER_COLOR: 'Cor de delineador',
  SKIN_PREFERRED_SCENT: 'Aroma',
  SKIN_ISSUE: 'Problemas de pele',
  HAIR_ISSUE: 'Problemas de cabelo',
  EXCLUSION_FAMILY: 'Exclusão mútua',
  SKIN_ISSUE_RULE: 'Restrições por problema de pele',
  HAIR_ISSUE_RULE: 'Restrições por problema de cabelo',
};

// How product selection reads each kind of group, so whoever registers knows what a mark means
export const kindHints = {
  SUITABILITY: 'Marque para quem o produto serve. Deixe em branco se servir para todos.',
  PREFERENCE:
    'Vai só para quem escolheu todas as opções marcadas. Deixe em branco se não se aplica.',
  ISSUE: 'O produto tem prioridade para quem tem um dos problemas marcados.',
};

// For questions that need an answer, so they don't offer leaving it blank
export const answerNeededHints = {
  SUITABILITY: 'Marque para quem o produto serve. Se servir para todos, use "Todos".',
  PREFERENCE: 'Vai só para quem escolheu todas as opções marcadas.',
};

// Rules have nothing in common to explain by kind, so each rule group has its own hint. One line
// per paragraph
export const groupHints = {
  EXCLUSION_FAMILY: 'A box leva no máximo um produto de cada um destes grupos, para não repetir '
    + 'a mesma função. Marque os grupos da função principal do produto. O tipo já marca os mais '
    + 'comuns como sugestão; desmarque ou marque outros quando o produto fugir do comum.\n'
    + 'Exemplos:\ndelineador e lápis de olho são "Traço para olhos";\ngloss e batom líquido, '
    + '"Produto para lábios" e "Produto líquido para lábios";\nloção corporal e creme para as '
    + 'mãos, "Hidratante, loção ou creme";\nsabonete líquido e em barra, "Sabonete corporal";\num '
    + 'sabonete facial em barra, "Sabonete em barra";\num hidratante labial líquido, "Produto para '
    + 'lábios" e "Produto líquido para lábios".',
  SKIN_ISSUE_RULE: 'Restringe quem pode receber o produto.',
  HAIR_ISSUE_RULE: 'Restringe quem pode receber o produto.',
};
